import { TipInvoice, TipsReportMeta } from 'model/TipsReport';

export interface TipsReportState {
    invoices: Array<TipInvoice>;
    totalTips?: number | string;
    totalAppointments?: number | string;
    totalTipsCount?: number | string;
    totalBookings?: number | string;
    status: TipsReportStatus;
    loading: boolean;
    meta?: TipsReportMeta;
}

export enum TipsReportStatus {
    Initial,
    Getting,
    GettingSuccess,
    Error
}
